/**
 * Given the purchase price, returns the minimum down payment in dollars.
 * 
 * @param {number} purchasePrice 
 * @returns {number} minimum down payment
 */
function getMinimumDownPaymentDollars(purchasePrice) {
    if (typeof purchasePrice !== 'number' || Number.isNaN(purchasePrice)) {
        return 0;
    }

    if (purchasePrice <= 500_000) {
        return 0.05 * purchasePrice;
    }

    if (purchasePrice >= 1_000_000) {
        return 0.2 * purchasePrice;
    }

    // 5% of first $500,000, 10% of the remainder
    return (0.05 * 500_000 + 0.1 * (purchasePrice - 500_000));
}

/**
 * 
 * @param {number} purchasePrice 
 * @returns {number} minimum down payment percent
 */
function getMinimumDownPaymentPercent(purchasePrice) {
    if (typeof purchasePrice !== 'number' || Number.isNaN(purchasePrice)) {
        return 0;
    }
    
    const downPayment = getMinimumDownPaymentDollars(purchasePrice);

    return downPayment / purchasePrice * 100;
}

export {
    getMinimumDownPaymentDollars,
    getMinimumDownPaymentPercent,
};